import { ActionTypes } from "@/App/constants/actionTypes";
import { PharmacyTypes } from "@/types";

type GetPharmacyAction = {
  type: typeof ActionTypes.GET_PHARMACY;
  payload: string;
};

export const getPharmacy = (id: string): GetPharmacyAction => {
  return {
    type: ActionTypes.GET_PHARMACY,
    payload: id,
  };
};

type GetPharmacyResultsAction = {
  type: typeof ActionTypes.GET_PHARMACY_RESULTS;
  payload: PharmacyTypes.Pharmacy;
};

export const getPharmacyResults = (data: PharmacyTypes.Pharmacy): GetPharmacyResultsAction => {
  return {
    type: ActionTypes.GET_PHARMACY_RESULTS,
    payload: data,
  };
};

export type PharmacyGetActions = GetPharmacyAction | GetPharmacyResultsAction;
